import * as React from "react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { canViewThisPage } from "@/lib/api/auth"
import { getMeterSize } from "@/lib/api/meter"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { meterSizeColumns } from "@/components/table/columns/meter-size-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import { AddMeterSizePage } from "./add"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/meter-size/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_metersize")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: MeterSizePage,
})

function MeterSizePage() {
  const [connectionTypes, setConnectionTypes] = React.useState<number[]>([])
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)

  const {
    data: meterReaderDetails,
    isError,
    isLoading,
  } = useQuery({
    queryKey: ["metersize", connectionTypes],
    queryFn: () => getMeterSize(connectionTypes),
  })

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <div className="space-y-4 p-4">
      <Header>Meter Size</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={meterSizeColumns}
          data={meterReaderDetails ?? []}
          search={{
            field: "size",
            label: "Meter Size",
          }}
          isLoading={isLoading}
          isError={isError}
          connectionTypes={connectionTypes}
          setConnectionTypes={setConnectionTypes}
        >
          <div className="flex w-full justify-end">
            <AddMeterSizePage />
            <Button
              onClick={(e) => reactToPrintFn()}
              variant="outline"
              className="mx-1 bg-primary text-white hover:bg-primary hover:text-white print:hidden"
            >
              <Icons.download className="mr-2 h-4 w-4" />
              Print Meter Size
            </Button>
            <ExportOperationModal
              tableData={meterReaderDetails ?? [{}]}
              fileName="Meter Size"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
      </div>
    </div>
  )
}
